import React from 'react'
import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import { FormControlLabel, Checkbox as UiCheckbox } from '@material-ui/core'

const Checkbox = props => {
  const { field, control, errors, handleShowFields, sectionId } = props
  const { id, label, description, defaultChecked, isTandC, htmlLabel, cssClass } = field
  const hasErrors = errors[id]

  return (
    <div
      className={classNames('fieldContainer', cssClass, { error: hasErrors })}
      key={`field-${id}`}
    >
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            className={classNames({ smallLabel: isTandC })}
            control={
              <UiCheckbox
                {...field}
                onChange={e => {
                  field.onChange(e.target.checked)
                  if (handleShowFields) handleShowFields(sectionId, !e.target.checked)
                }}
                label={label && !htmlLabel ? label : undefined}
                defaultChecked={defaultChecked}
              />
            }
            label={
              htmlLabel ? (
                <span className="htmlLabel" dangerouslySetInnerHTML={htmlLabel}></span>
              ) : (
                label
              )
            }
          />
        )}
      />

      {hasErrors && (
        <div className="error-message">
          <img src="/themes/thrifty/assets/images/form-error.svg" />
          {errors[id]?.message}
        </div>
      )}

      {description && <p className="fieldDescription">{description}</p>}
    </div>
  )
}

export default Checkbox
